<template>
  <svg
    class="breadcrumb-chevron"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.35303 11.5181C8.15928 11.7118 7.84053 11.7118 7.64678 11.5181L1.64678 5.51807C1.45303 5.32432 1.45303 5.00557 1.64678 4.81182C1.84053 4.61807 2.15928 4.61807 2.35303 4.81182L7.9999 10.4587L13.6468 4.81182C13.8405 4.61807 14.1593 4.61807 14.353 4.81182C14.5468 5.00557 14.5468 5.32432 14.353 5.51807L8.35303 11.5181Z"
      fill="#194458"
    />
  </svg>
</template>

<style scoped>
.breadcrumb-chevron {
  margin-left: 4px;
  display: inline-block;
  vertical-align: middle;
}
</style>
